import { useTheme } from 'styled-components'
import { DIALOG_ACTION_SHOP } from '../config/constants'

const buildStyles = (colors) => ({
  labelStyle: {
    display: 'block',
    fontSize: '0.75rem',
    color: colors('foreground', 0.45),
    marginBottom: '0.25rem',
    marginTop: '0.75rem',
    textTransform: 'uppercase',
  },
  sectionStyle: {
    marginTop: '1.25rem',
    paddingTop: '1rem',
    borderTop: `1px solid ${colors('foreground', 0.1)}`,
  },
  tinyInput: {
    background: colors('shadow', 0.6),
    border: `1px solid ${colors('foreground', 0.2)}`,
    color: colors('highlight'),
    padding: '0.2rem 0.4rem',
    fontFamily: "'Silkscreen', monospace",
    fontSize: '0.75rem',
    boxSizing: 'border-box',
  },
  cardStyle: {
    padding: '0.5rem',
    border: `1px solid ${colors('foreground', 0.08)}`,
    background: colors('shadow', 0.3),
    marginBottom: '0.5rem',
  },
  addBtnStyle: {
    background: 'none',
    border: 'none',
    color: colors('foreground', 0.35),
    cursor: 'pointer',
    fontFamily: "'Silkscreen', monospace",
    fontSize: '0.75rem',
    padding: '0.2rem 0',
  },
  removeBtnStyle: {
    background: 'none',
    border: 'none',
    color: colors('danger'),
    cursor: 'pointer',
    fontFamily: "'Silkscreen', monospace",
    fontSize: '0.75rem',
    padding: '0 0.2rem',
    flexShrink: 0,
  },
  dialogIndexStyle: { color: colors('foreground', 0.3), fontSize: '0.7rem' },
  repeatLabelStyle: { display: 'flex', alignItems: 'center', gap: '0.25rem', color: colors('foreground', 0.35), fontSize: '0.7rem', margin: 0 },
  shopLabelStyle: { display: 'flex', alignItems: 'center', gap: '0.25rem', color: colors('highlight'), fontSize: '0.7rem', margin: 0 },
})

export const DialogEditor = ({ dialogs, onChange, label }) => {
  const { colors } = useTheme()
  const {
    labelStyle, sectionStyle, tinyInput, cardStyle,
    addBtnStyle, removeBtnStyle, dialogIndexStyle, repeatLabelStyle, shopLabelStyle,
  } = buildStyles(colors)

  const updateDialog = (i, changes) =>
    onChange(dialogs.map((d, di) => di === i ? { ...d, ...changes } : d))

  const updateLine = (di, li, value) => {
    const lines = dialogs[di].lines.map((l, idx) => idx === li ? value : l)
    updateDialog(di, { lines })
  }

  return (
    <div style={sectionStyle}>
      <label style={labelStyle}>{label}</label>
      {dialogs.map((dlg, di) => (
        <div key={di} style={cardStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.35rem' }}>
            <span style={dialogIndexStyle}>Dialog {di + 1}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <label style={repeatLabelStyle}>
                <input
                  type="checkbox"
                  checked={!!dlg.repeat}
                  onChange={(e) => updateDialog(di, { repeat: e.target.checked })}
                />
                Repeat
              </label>
              <label style={shopLabelStyle}>
                <input
                  type="checkbox"
                  checked={dlg.action === DIALOG_ACTION_SHOP}
                  onChange={(e) => updateDialog(di, { action: e.target.checked ? DIALOG_ACTION_SHOP : undefined })}
                />
                Shop
              </label>
              <button
                type="button"
                style={removeBtnStyle}
                onClick={() => onChange(dialogs.filter((_, i) => i !== di))}
              >
                ✕
              </button>
            </div>
          </div>
          {(dlg.lines || []).map((line, li) => (
            <div key={li} style={{ display: 'flex', gap: '0.25rem', marginBottom: '0.2rem' }}>
              <input
                value={line}
                onChange={(e) => updateLine(di, li, e.target.value)}
                style={{ ...tinyInput, flex: 1 }}
              />
              <button
                type="button"
                style={removeBtnStyle}
                onClick={() => updateDialog(di, { lines: dlg.lines.filter((_, i) => i !== li) })}
              >
                ✕
              </button>
            </div>
          ))}
          <button
            type="button"
            style={addBtnStyle}
            onClick={() => updateDialog(di, { lines: [...(dlg.lines || []), ''] })}
          >
            + line
          </button>
        </div>
      ))}
      <button
        type="button"
        style={addBtnStyle}
        onClick={() => onChange([...dialogs, { lines: [''], repeat: false }])}
      >
        + Add dialog
      </button>
    </div>
  )
}
